import { render, staticRenderFns } from "./TaxDocument.vue?vue&type=template&id=e03160d4&scoped=true"
import script from "./TaxDocument.vue?vue&type=script&lang=js"
export * from "./TaxDocument.vue?vue&type=script&lang=js"
import style0 from "./TaxDocument.vue?vue&type=style&index=0&id=e03160d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03160d4",
  null
  
)

export default component.exports